import { functions } from "configs/firebase";
import { httpsCallable } from "firebase/functions";

const sendMail = httpsCallable(functions, "sendMail");

export { sendMail };
